import React, { useState } from "react";

type Atividade = {
  descricao: string;
  ativa: boolean;
}

export function FormListaAtividades() {
  const [atividades, setAtividades] = useState<Atividade[]>([{ descricao: '', ativa: true }]);

  const add = () => {
    setAtividades(atividades.concat({ descricao: '', ativa: true }))
  }

  const remove = (index: number) => {
    if(atividades.length > 1) {
      const copyAtividades = [...atividades];
      copyAtividades.splice(index, 1);
      setAtividades(copyAtividades)
    }
  }

  const onChange = (index: number, key: string, value: any) => {
    const copyAtividades = [...atividades];
    //@ts-ignore
    copyAtividades[index][key] = value;
    setAtividades(copyAtividades)
  }

  return (
    <div>
      
      {atividades.map((atividade, index) => (
        <div className="grid-12 container container--form " key={index}>
          <label className="grid-9 grid--m-6 grid--p-12 form">
            <span className="label ">Descrição</span>
            <input type='text' name='atividades[][descricao]' required placeholder='Obrigatório' maxLength={255} value={atividade.descricao} onChange={(e) => onChange(index, 'descricao', e.target.value)} />
          </label>
          <label className="form form--slider grid-1 grid--m-2 grid--p-12">
            {/* @ts-ignore */}
            <input type='checkbox' name='atividades[][ativa]' checked={atividade.ativa} onChange={(e) => onChange(index, 'ativa', e.target.checked)} value={atividade.ativa}/>
            <span className="label">Ativa</span>
            <span className="slider"/>
          </label>
          <div className="form__acoes grid-2 grid--m-4 grid--p-12">
            <button type='button' className="bt" onClick={add}>Adicionar</button>
            {atividades.length > 1 && (<button className="bt bt--alerta" onClick={() => remove(index)}>Remover</button>)}
          </div>
        </div>
      ))}
    </div>
  )
}